/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLabDto } from '../../models/create-lab-dto';
import { Lab } from '../../models/lab';

export interface LabControllerCreate$Params {
      body: CreateLabDto
}

export function labControllerCreate(http: HttpClient, rootUrl: string, params: LabControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<Lab>> {
  const rb = new RequestBuilder(rootUrl, labControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Lab>;
    })
  );
}

labControllerCreate.PATH = '/lab';
